import React, { useEffect, useState, useMemo } from "react";
import { DataGrid } from "@mui/x-data-grid";
import {
  TextField,
  Box,
  Paper,
  Typography,
  InputAdornment,
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import axios from "axios";
import Cookies from "universal-cookie";

import CrearPermisos from "./CreaPermisos";
import EliminarPermisos from "./EliminaPermisos";
import { obtenertodospermisos } from "../../Services/Rest";

function InfoPermisos() {
  const cookie = new Cookies();

  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState("");

  useEffect(() => {
    axios({
      auth: { username: "webapp", password: "762tsfsy9826kk87ytttsf" },
      method: "get",
      url: obtenertodospermisos + cookie.get("ID"),
    })
      .then((res) => {
        const data = res.data.map((item) => ({
          id: item.id,
          reporte: item.reporte,
          usuario: item.nombreUsuario,
        }));
        setRows(data);
      })
      .catch(console.log)
      .finally(() => setLoading(false));
  }, []);

  // 🔍 filtro global
  const filteredRows = useMemo(() => {
    return rows.filter((row) =>
      Object.values(row).join(" ").toLowerCase().includes(search.toLowerCase()),
    );
  }, [search, rows]);

  const columns = [
    { field: "id", headerName: "ID", width: 70 },
    { field: "reporte", headerName: "Reporte", flex: 1 },
    { field: "usuario", headerName: "Usuario", flex: 1 },
    {
      field: "acciones",
      headerName: "",
      width: 120,
      sortable: false,
      renderCell: (params) => <EliminarPermisos id={params.row.id} />,
    },
  ];

  return (
    <Box sx={{ p: 3 }}>
      {/* 🔥 HEADER SUPER CLEAN */}
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          mb: 2,
        }}
      >
        <Typography variant="h6" fontWeight={600}>
          Permisos
        </Typography>

        <CrearPermisos />
      </Box>

      {/* 🔥 BUSCADOR DESTACADO (FLOATING STYLE) */}
      <Box sx={{ mb: -3, zIndex: 2, position: "relative" }}>
        <Paper
          elevation={4}
          sx={{
            p: 1.5,
            borderRadius: 3,
            width: 350,
            mx: "auto",
          }}
        >
          <TextField
            fullWidth
            size="small"
            placeholder="Buscar en toda la tabla..."
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon />
                </InputAdornment>
              ),
            }}
          />
        </Paper>
      </Box>

      {/* 🔥 CARD PRINCIPAL */}
      <Paper
        elevation={2}
        sx={{
          borderRadius: 3,
          pt: 4, // espacio para que no choque con el buscador
          overflow: "hidden",
        }}
      >
        <Box sx={{ height: "70vh" }}>
          <DataGrid
            rows={filteredRows}
            columns={columns}
            loading={loading}
            pageSize={5}
            rowsPerPageOptions={[5, 10, 20]}
            pagination
            disableSelectionOnClick
            sx={{
              border: "none",

              "& .MuiDataGrid-columnHeaders": {
                backgroundColor: "#f8fafc",
                fontSize: "0.85rem",
              },

              "& .MuiDataGrid-row:hover": {
                backgroundColor: "#f1f5f9",
              },
            }}
          />
        </Box>
      </Paper>
    </Box>
  );
}

export default InfoPermisos;
